module.exports = __webpack_public_path__ + "img/5331.d65998c2.png";